var ezdia;
(function (ezdia) {
    var $BODY = $('body');
    var $DOC = $(document);
    var TYPE = 'scrollingNav';
    var NAME = 'scrollingNav';
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var directionBtnCls = 'active';
    var activelinkCls = 'active';
    var navbarBtn = '#ez-form-navbar-toogle-btn';
    var DEFAULT = {
        selector: 'ul.ez-nav-pills',
        clickable: false,
        tabs: false,
        leftArrowHandler: '[data-arrow="left"]',
        rightArrowHandler: '[data-arrow="right"]',
        minSroll: 200,
        buttonMargin: 32,
        classes: 'ez-scroll-nav-pills',
        wrapper: '[data-nav="scroll"]',
        pageHeader: '',
        sticky: false,
        stickyCls: 'ez-scroll-nav-pills-form-sticky',
        placeholderCls: 'ez-scroll-nav-pills-form-sticky-placeholder',
        roundoff: 15,
        offsets: []
    };
    var ScrollingNav = /** @class */ (function () {
        function ScrollingNav(elem, options) {
            this.elem = elem;
            this.init(options);
        }
        Object.defineProperty(ScrollingNav, "Default", {
            get: function () {
                return DEFAULT;
            },
            enumerable: false,
            configurable: true
        });
        ScrollingNav.prototype.init = function (options) {
            this.type = TYPE;
            this.id = this.elem.id;
            this.$elem = $(this.elem);
            this.options = this.getOptions(options);
            this.wrapper = this.$elem.find(this.options.wrapper);
            this.nav = this.$elem.find(this.options.selector);
            this.leftArrow = this.$elem.find(this.options.leftArrowHandler);
            this.rightArrow = this.$elem.find(this.options.rightArrowHandler);
            this.pageHeaderHeight = 0;
            this.isIE = !!document.documentMode;
            if (!this.wrapper.length) {
                return;
            }
            this.$elem.addClass(this.options.classes).removeClass('hide');
            this.render();
        };
        /**
         * This function disable scroll
         */
        ScrollingNav.prototype.disable = function () {
            this.toggleLeftArrow();
            this.toggleRightArrow();
            this.nav.removeClass('transition');
            this.translateX(0);
        };
        /**
         * This function reconstruct scrolling navbar
         */
        ScrollingNav.prototype.refresh = function () {
            this.disable();
            this.render(true);
        };
        /**
         * This function destroy scrollbar instance
         */
        ScrollingNav.prototype.destroy = function (id) {
            $(window).off(".scrollingNav" + id);
        };
        /**
         * This Method merger all default options with user input option and return extended options.
         */
        ScrollingNav.prototype.getOptions = function (options) {
            return __assign(__assign(__assign({}, DEFAULT), this.$elem.data()), options);
        };
        /**
         * This Method create scrolling menu and hide and show left right dropdown
         */
        ScrollingNav.prototype.render = function (refresh) {
            var scroll = this.hasScrolling();
            var items = null;
            if (scroll) {
                this.nav.addClass('transition');
                this.toggleRightArrow('block');
            }
            else {
                this.disable();
            }
            items = this.nav.find(' > li');
            if (!refresh) {
                items.each(function each(i) {
                    var item = $(this);
                    var oWidth = item.outerWidth();
                    var posL = item.position().left;
                    item.data('width', oWidth);
                    item.data('pos-left', posL);
                    item.attr('data-index', i);
                });
            }
            else {
                items.css({
                    display: ''
                });
            }
            this.movetoActive();
            if (!refresh) {
                this.events();
            }
            else if (this.options.offsets.length) {
                // this.resetOffSet();
            }
            this.wrapper.addClass('rendering-done');
        };
        ScrollingNav.prototype.getOffSet = function () {
            var e_1, _a;
            var offsetH = 0;
            try {
                for (var _b = __values(this.options.offsets), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var elem = _c.value;
                    offsetH += $("#" + elem).outerHeight() || 0;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return offsetH;
        };
        ScrollingNav.prototype.resetOffSet = function () {
            this.scrollspy.data('bs.scrollspy').options.offset = this.getOffSet();
        };
        ScrollingNav.prototype.events = function () {
            var _this = this;
            var self = this;
            var options = this.options;
            var win = $(window).off("." + this.type);
            var FORM_EVENT_STICK = ezdia.config.CUS_EVENTS.FORM_EVENT_STICK;
            $DOC.off(FORM_EVENT_STICK).on(FORM_EVENT_STICK, function () {
                $BODY.scrollspy('refresh');
            });
            win.on("resize." + this.type, function () {
                if (!_this.resize) {
                    _this.resize = true;
                    setTimeout(function () {
                        _this.refresh();
                        _this.resize = false;
                    }, 1000);
                }
            });
            this.$elem.off("click." + this.type, 'a:not([data-toggle="dropdown"])');
            if (options.clickable) {
                if (options.pageHeader) {
                    this.$pageHeader = $(options.pageHeader);
                    this.pageHeaderHeight = this.$pageHeader.outerHeight();
                }
                else if (this.options.offsets.length) {
                    this.pageHeaderHeight = this.getOffSet();
                }
                this.scrollspy = $('body')
                    .scrollspy({
                    target: "#" + this.id,
                    offset: this.pageHeaderHeight + 10
                })
                    .on('activate.bs.scrollspy', function () {
                    if (!_this.isIE) {
                        _this.refresh();
                    }
                });
                this.$elem.on("click." + this.type, 'a:not([data-toggle="dropdown"])', function click(e) {
                    self.clickable(e, this);
                });
            }
            else if (options.tabs) {
                this.$elem.on("shown.bs.tab." + this.type, 'a:not([data-toggle="dropdown"])', function shown() {
                    self.$elem.find('li[data-index]').removeClass(activelinkCls);
                    self.nav
                        .find("[href=\"" + this.hash + "\"]")
                        .parent('li')
                        .addClass(activelinkCls);
                    self.movetoActive();
                });
            }
            if (options.sticky) {
                this.activateScroll(win);
                $(navbarBtn).on("click." + this.type, 'a', function () {
                    _this.toggleNavbar();
                });
            }
            this.leftArrow.on("click." + this.type, 'ul [data-toggle="dropdown"]', function click(e) {
                $(this).parent().toggleClass('open');
                e.stopPropagation();
            });
            this.rightArrow.on("click." + this.type, 'ul [data-toggle="dropdown"]', function click(e) {
                $(this).parent().toggleClass('open');
                e.stopPropagation();
            });
        };
        ScrollingNav.prototype.hasScrolling = function () {
            this.widths = this.wrapper.outerWidth();
            this.scrollWidths = this.wrapper.get(0).scrollWidth;
            this.toScroll = this.scrollWidths - this.widths;
            if (!this.isSticky) {
                this.tops = this.$elem.offset().top;
            }
            return !!this.toScroll;
        };
        ScrollingNav.prototype.movetoActive = function () {
            var elem = this.wrapper.find("." + activelinkCls);
            var sibNext = elem.next();
            var lefts = 0;
            var movex = 0;
            var outerwidths = 0;
            var widths = 0;
            if (elem.length) {
                lefts = elem.position().left;
                outerwidths = elem.outerWidth();
            }
            widths = lefts + outerwidths;
            if (widths > this.widths) {
                if (sibNext.length) {
                    widths = sibNext.position().left + this.options.buttonMargin;
                }
                movex = widths - this.widths;
                this.translateX(movex);
                this.toggleLeftArrow('block');
            }
            else {
                this.translateX(0);
            }
        };
        ScrollingNav.prototype.toggleLeftArrow = function (display) {
            if (display) {
                this.leftArrow.addClass(directionBtnCls);
            }
            else {
                this.leftArrow.removeClass(directionBtnCls);
            }
        };
        ScrollingNav.prototype.toggleRightArrow = function (display) {
            if (display) {
                this.rightArrow.addClass(directionBtnCls);
            }
            else {
                this.rightArrow.removeClass(directionBtnCls);
            }
        };
        ScrollingNav.prototype.translateX = function (movex) {
            this.nav.css({
                transform: "translateX(-" + movex + "px)"
            });
            this.nav.data('translateX', movex);
            this.createHiddenDropdown(movex);
        };
        ScrollingNav.prototype.createHiddenDropdown = function (movex) {
            // tslint:disable-next-line:variable-name
            var self = this;
            var leftul = this.leftArrow.removeClass('open').find('ul').empty();
            var rightul = this.rightArrow.removeClass('open').find('ul').empty();
            var leftHasItems = false;
            var rightHasItems = false;
            this.nav.find('> li').each(function each() {
                var item = $(this).css({
                    visibility: '',
                    display: ''
                });
                var visiblity = '';
                var display = '';
                var posL = item.data('posLeft');
                var oWidth = item.data('width');
                if (movex && posL - 30 < movex) {
                    // if ((posL + oWidth ) < movex) {
                    visiblity = 'hidden';
                    // }
                    leftul.prepend(item.clone());
                    leftHasItems = true;
                }
                else if (posL + oWidth - movex > self.widths - 30) {
                    if (item.hasClass('active') && !item.next().length) {
                        return;
                    }
                    if (posL + oWidth - movex > self.widths) {
                        display = 'none';
                    }
                    rightul.append(item.clone());
                    rightHasItems = true;
                }
                item.css({
                    visibility: visiblity,
                    display: display
                });
            });
            this.toggleLeftArrow(leftHasItems);
            this.toggleRightArrow(rightHasItems);
        };
        ScrollingNav.prototype.clickable = function (e, elem) {
            var bodys = $('html, body');
            if (elem.hash !== '') {
                e.preventDefault();
                var id = elem.hash;
                var contener = $(id);
                var heights = 0;
                if (contener.length) {
                    heights = contener.offset().top - this.pageHeaderHeight;
                    if (this.isIE) {
                        bodys.scrollTop(heights);
                    }
                    else {
                        bodys.animate({
                            scrollTop: heights
                        }, 1000);
                    }
                }
            }
        };
        ScrollingNav.prototype.activateScroll = function (win) {
            var _this = this;
            if (typeof this.sticky !== 'boolean') {
                this.stickyElem = $(this.options.sticky);
            }
            else {
                this.stickyElem = this.$elem;
            }
            this.createPlaceholder();
            win.on("scroll." + this.type + this.id, function () {
                if (!_this.scroll) {
                    _this.scroll = true;
                    setTimeout(function () {
                        _this.fixNav.call(_this);
                        if (_this.isIE) {
                            _this.refresh();
                        }
                        _this.scroll = false;
                    }, 500);
                }
            });
        };
        ScrollingNav.prototype.fixNav = function () {
            var self = this;
            var options = this.options;
            var windowTop = $(window).scrollTop() + options.roundoff;
            if (this.tops >= windowTop) {
                this.isSticky = false;
                self.stickyElem.removeClass(options.stickyCls);
                this.$pageHeader.fadeIn();
                $('body').scrollspy('refresh');
            }
            else if (!this.isSticky) {
                this.isSticky = true;
                this.$pageHeader.fadeOut(function () {
                    self.stickyElem.addClass(options.stickyCls);
                    self.refresh();
                });
                $('body').scrollspy('refresh');
            }
        };
        ScrollingNav.prototype.createPlaceholder = function () {
            var heights = 0;
            var container = this.stickyElem.next("." + this.options.placeholderCls);
            if (container.length) {
                return;
            }
            heights = this.stickyElem.outerHeight(true);
            container = $('<div>', {
                class: "hide " + this.options.placeholderCls,
                css: {
                    height: heights
                }
            });
            this.stickyElem.after(container);
        };
        ScrollingNav.prototype.toggleNavbar = function () {
            var self = this;
            var win = $(window);
            var scrollEvent = "scroll." + this.type + this.id + ".toggle";
            this.$pageHeader.fadeIn().css('z-index', '20000000000000');
            win.on(scrollEvent, function () {
                win.off(scrollEvent);
                self.$pageHeader.fadeOut();
            });
        };
        return ScrollingNav;
    }());
    // PLUGIN DEFINITION
    // =========================
    var publicMethods = {
        disable: ScrollingNav.prototype.disable,
        refresh: ScrollingNav.prototype.refresh,
        destroy: ScrollingNav.prototype.destroy
    };
    function jQueryInterface(option) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (typeof option === 'string') {
            return invokePublicMethod.call(this, option, args);
        }
        return createNewInstance.call(this, option);
    }
    function invokePublicMethod(methodName, args) {
        if (publicMethods[methodName]) {
            var inputObject = retrieveObjectFromElement(this);
            var result = publicMethods[methodName].apply(inputObject, args);
            if (typeof result === 'undefined') {
                return $(this);
            }
            return result;
        }
        throw new Error("method '" + methodName + "()' does not exist for input list.");
    }
    // eslint-disable-next-line consistent-return
    function retrieveObjectFromElement(element) {
        var inputObject = $(element).data('ez.scrollingNav');
        if (inputObject && inputObject instanceof ScrollingNav) {
            return inputObject;
        }
    }
    function createNewInstance(option) {
        var $this = $(this);
        $this.each(function each() {
            var self = $(this);
            var data = self.data('ez.scrollingNav');
            var options = typeof option === 'object' && option;
            if (!data) {
                self.data('ez.scrollingNav', (data = new ScrollingNav(this, options)));
            }
            if (typeof option === 'string') {
                data[option]();
            }
        });
        return $this;
    }
    $.fn[NAME] = jQueryInterface;
    $.fn[NAME].Constructor = ScrollingNav;
    $.fn[NAME].noConflict = function noConflict() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return jQueryInterface;
    };
})(ezdia || (ezdia = {}));
